var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1C28E131-EB5B-4EEE-A8A6-A02A15C9EF88") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1-home-aba/carreira-juridica",
    transform: "translate(-24.000000, -1029.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-blog",
    transform: "translate(0.000000, 797.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "news-2",
    transform: "translate(1.000000, 2.000000)",
    fill: "#1717CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "news"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1328125,0 L18.1328125,9.4140625 L22,9.4140625 L22,17.65625 C22,18.898961 20.9307844,19.9187718 19.5846852,19.9953804 L19.421875,20 L2.578125,20 C1.21114289,20 0.089351043,19.0279858 0.00508152567,17.8042593 L0,17.65625 L0,0 L18.1328125,0 Z M16.84375,1.171875 L1.2890625,1.171875 L1.2890625,17.65625 C1.2890625,18.2620716 1.79727404,18.761946 2.44650693,18.8220638 L2.578125,18.828125 L17.1905212,18.828125 C17.0019095,18.5324097 16.8818615,18.1962243 16.8514112,17.8374417 L16.84375,17.65625 L16.84375,1.171875 Z M20.7109375,10.5859375 L18.1328125,10.5859375 L18.1328125,17.65625 C18.1328125,18.3024597 18.7110443,18.828125 19.421875,18.828125 C20.0884361,18.828125 20.6381602,18.3661145 20.704272,17.7759028 L20.7109375,17.65625 L20.7109375,10.5859375 Z",
    id: "Shape",
    stroke: "#1717CE",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64,7.2 L15.84,7.2 L15.84,2.4 L2.64,2.4 L2.64,7.2 Z M3.95125828,3.59008264 L14.5287417,3.59008264 L14.5287417,6.00991736 L3.95125828,6.00991736 L3.95125828,3.59008264 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.64 8.4 9.24 8.4 9.24 9.6 2.64 9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.12 8.4 15.4 8.4 15.4 9.6 10.12 9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.64 10.4 9.24 10.4 9.24 11.6 2.64 11.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.12 10.4 15.4 10.4 15.4 11.6 10.12 11.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.64 12.8 9.24 12.8 9.24 14 2.64 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.64 15.2 9.24 15.2 9.24 16.4 2.64 16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.12,16.4 L15.4,16.4 L15.4,12.8 L10.12,12.8 L10.12,16.4 Z M11.4290909,14 L14.0909091,14 L14.0909091,15.2 L11.4290909,15.2 L11.4290909,14 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlog);
export default __webpack_public_path__ + "static/media/ic-blog.d5bc1b8f8400513a28bb9e814a68dd27.svg";
export { ForwardRef as ReactComponent };